import React, { CSSProperties } from 'react'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'

import type { HelpType } from '../../../core'
import { PopularTopicsRow } from './PopularTopicsRow'

export interface ListItem {
  guid?: string
  name: string
  subtitle?: string
  type?: HelpType
}

interface PopularTopicsListProps {
  sx?: CSSProperties
  list: ListItem[]
  onClick?: (title: string, type: ListItem['type']) => void
}

export const PopularTopicsList: React.FC<PopularTopicsListProps> = ({ list, onClick, sx }) => (
  <Box sx={{ bgcolor: 'background.paper' }}>
    <List sx={{ '& .MuiDivider-root:last-child': { ml: 0 } }}>
      {list.map(({ name, guid, subtitle, type }, index) => (
        <React.Fragment key={`${name}-${index}`}>
          <PopularTopicsRow
            guid={guid}
            name={name}
            onClick={() => onClick?.(name, type!)}
            subtitle={subtitle}
            sx={sx}
          />
          <Divider sx={{ ml: 24 }} />
        </React.Fragment>
      ))}
    </List>
  </Box>
)
